import React from 'react';
import './style.css';
import dayjs from 'dayjs';
import { toCurrency } from '@/helpers/masks/toCurrency';
import { EventFractional } from '@/model/EventFractional';

interface Props {
  ticketsFractional: EventFractional[];
}

export const EventFractionalReportUI: React.FC<Props> = ({ ticketsFractional }) => {
  if (!ticketsFractional || ticketsFractional.length === 0) {
    return <div className="efr-empty">Nenhum pedido fracionado encontrado.</div>;
  }

  return (
    <div className="efr-wrapper">
      {ticketsFractional.map(order => {
        const total = order.totalValue;
        const paid = order.paidAmount;
        const remaining = order.remainingValue;
        const base = total;
        const paidPct = (paid * 100) / base;
        const itemLabel = order.lable;

        return (
          <div key={order.orderId} className="efr-row">
            <div className="efr-row-header">
              <div className="efr-col efr-col-title">
                <strong>{itemLabel}</strong>
                <span className="efr-muted">{dayjs(order.orderDate).format('DD/MM/YYYY')}</span>
              </div>

              <div className="efr-col">
                <span>PDV</span>
                <strong>{order.pdv}</strong>
              </div>

              <div className="efr-col">
                <span>Total</span>
                <strong>{toCurrency(total)}</strong>
              </div>

              <div className="efr-col">
                <span>Pago</span>
                <strong>{toCurrency(paid)}</strong>
              </div>

              <div className="efr-col">
                <span>Falta</span>
                <strong>{toCurrency(remaining)}</strong>
              </div>
            </div>

            {/* Barra de progresso */}
            <div className="efr-progress">
              <div className="efr-progress-bar">
                <div className="efr-progress-fill" style={{ width: `${paidPct}%` }} />
              </div>
              <div className="efr-progress-label">{paidPct.toFixed(0)}% pago</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
